export const GETCONFIG_REQUEST_WHITE_LABELING = 'GETCONFIG_REQUEST_WHITE_LABELING'
export const GETCONFIG_SUCCESS_WHITE_LABELING = 'GETCONFIG_SUCCESS_WHITE_LABELING'
export const GETCONFIG_FAILURE_WHITE_LABELING = 'GETCONFIG_FAILURE_WHITE_LABELING'
